import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconMegaphone_16 = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 16 16"
    data-fill-none
  >
    <path
      d="M5.69233 10.0529H4.30771C3.69567 10.0529 3.10869 9.80978 2.67591 9.377C2.24313 8.94422 2 8.35725 2 7.74521C2 7.13317 2.24313 6.54619 2.67591 6.11341C3.10869 5.68063 3.69567 5.4375 4.30771 5.4375H5.69233V10.0529Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.69238 10.0526C8.4008 10.0529 11.0486 10.8545 13.3023 12.3566L14.0001 12.8219V2.66797L13.3023 3.1332C11.0486 4.63533 8.4008 5.43699 5.69238 5.43722V10.0526Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.69238 10.0527C5.69199 10.657 5.81454 11.255 6.05258 11.8105C6.29061 12.3659 6.63916 12.8671 7.07701 13.2835"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
IconMegaphone_16.displayName = 'IconMegaphone_16';
